import React from "react";
import { Outlet } from "react-router-dom";
import Navigation from "./HomePage/Navigation";
import { useMediaQuery } from "react-responsive";
import ScrollToTop from "../../ScrollToTop";

const Home = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  return (
    <div>
      <ScrollToTop />
      <Navigation isTabletOrMobile={isTabletOrMobile} />
      <Outlet />
    </div>
  );
};

export default Home;
